import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from 'recharts';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useGetDashboardGroupedDataQuery } from '../services/dashboard.endpoints';

const PurchasesChart = () => {
  const { data, error, isLoading } = useGetDashboardGroupedDataQuery();
  console.log('PurchasesChart', error);

  if (isLoading) return <CircularProgress />;
  if (error) return <Typography>Error loading data</Typography>;

  const purchasesData = data?.purchases || [];

  return (
    <Box>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={purchasesData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={(d) => `${d._id.month}-${d._id.day}`} />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="totalPurchases" stroke="#8884d8" />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default PurchasesChart;
